import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a71fbc60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dataset-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-header-container" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "sub-title" }, "Data detail")
], -1))
const _hoisted_3 = { class: "dataset-detail" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Name ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Dataset Title ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Date ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Biotech Category ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Biotech ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Journal ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Species ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Tissue ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" N_Unit ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" N_Gene ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-header-container" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "sub-title" }, "Browse spatial gene expression")
], -1))
const _hoisted_15 = { class: "select-container" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Download ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_GeneExpression = _resolveComponent("GeneExpression")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_GeneColorView = _resolveComponent("GeneColorView")!
  const _component_GeneAttributeView = _resolveComponent("GeneAttributeView")!
  const _component_GeneExpressionCompare = _resolveComponent("GeneExpressionCompare")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.name), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.dataset_name_long), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.date), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.biotech_category), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.biotech), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.journal), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.species), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.tissue), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.n_unit), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.data.n_gene), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _hoisted_14,
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_el_button, {
        size: "default",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.download()))
      }, {
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeName) = $event)),
        type: "border-card",
        stretch: true,
        class: "gene-tab",
        onTabClick: _ctx.handleClick
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "Expression View",
            name: "geneExpression",
            lazy: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_GeneExpression, { ref: "gene" }, null, 512)
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "SOView",
            name: "geneColorView",
            lazy: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_GeneColorView, { ref: "geneColorView" }, null, 512)
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Annotation View",
            name: "geneAttributeView",
            lazy: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_GeneAttributeView, { ref: "geneAttributeView" }, null, 512)
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "Comparsion View",
            name: "geneExpressionCompare",
            lazy: true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_GeneExpressionCompare, { ref: "geneExpressionCompare" }, null, 512)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onTabClick"])
    ])
  ]))
}